// gets sent with the satisfaction survey and needs to be returned intact for the response to be accepted (this is an unprotected endpoint otherwise)

const survey_secret = "dfrTp8yjx2oo6rA1mlQ7v8HRKEiBLVeK";

module.exports = survey_secret;